import axiosInstance from '@/api/axiosInstance';
import { UpdateSkillPayload, UpdateSkillResponse } from './types';

/**
 * Update an existing skill
 * PUT /api/learning-center/skills/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const updateSkill = async (
  id: number,
  payload: UpdateSkillPayload
): Promise<UpdateSkillResponse> => {
  try {
    const response = await axiosInstance.put<UpdateSkillResponse>(
      `/api/learning-center/skills/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating skill ${id}:`, error);
    throw error;
  }
};
